<template><div><h1>VUX V2.7.8 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix `on-hide` event trigger twice #2379</li>
<li>[fix] fix cannot set `show` to `true` initially</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[fix] Fix chain mode get value is wrong when the children is empty data.</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] fix popup-radio component does not support the border-intent property of the cell component.</li>
</ul>
<h2><a href="/en/components/wechat.html">Wechat</a></h2>
<ul><li>[feature] support 1.3.0</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.8 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.8-137.vue?32762ce3